module.exports = __webpack_public_path__ + "static/media/21a-01-HOME_JoaquinBoz_taller.2ec6b04f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/21a/21a-01-HOME_JoaquinBoz_taller.jpg
// module id = 255
// module chunks = 0